import {
    TableViewStore,
    BaseListViewStore,
    BaasicDropdownStore,
    DateRangeQueryPickerStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import {ScheduleService} from 'application/schedule/services';
import {FacilityService} from 'application/facility/services';
import {GenerateForm} from 'application/schedule/forms';
import { toDate } from 'core/utils';
import _ from 'lodash';

@applicationContext
class ScheduleViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);   
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'schedule',
            autoInit: true,
            routes: {
            },
            authorization:{
                delete: 'portalSection.delete',
                update: 'portalSection.update'
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await scheduleService.find(_.extend(params, {embed: 'AccountRep,Facility,AreaOfCare', isOnHold:false}));
                        const res = _.extend(response.data, {
                            item: _.map(response.data.item, (item => {
                                return _.extend(
                                    item, { 
                                        date: toDate(item.date),  
                                        orderingScheduleDate: toDate(item.orderingScheduleDate),     
                                        facility: item.facility.name,
                                        areaOfCare: item.areaOfCare ? item.areaOfCare.name : 'All',
                                        accountRep: item.accountRep ? item.accountRep.firstName + ' ' + item.accountRep.lastName : '',
                                    }
                                );
                            }))
                        })
                        return res;
                    },
                    delete: async (item) => {
                        await scheduleService.delete(item);
                    }
                }
            }
        });

        this.goToCalendar = (route) => {
            let queryParams = rootStore.routerStore.routerState.queryParams;
            this.rootStore.routerStore.goTo(
                route,
                null,
                { areaOfCareId: queryParams.areaOfCareId, facilityId: queryParams.facilityId, dateFrom: queryParams.dateFrom, dateTo: queryParams.dateTo}
            );
        };

        this.generate = async (form) => {
            this.tableStore.suspend();
            var formValues = form.values();
            try{
                await scheduleService.generate(formValues);
                await this.queryUtility.fetch();
                this.rootStore.notificationStore.success("Schedule dates successfully generated.");
            }catch(err){
                this.rootStore.notificationStore.error("Error occured while trying to generate schedule dates.");
            }
            this.tableStore.resume();
        };

        this.generateForm = new GenerateForm({onSuccess: this.generate});

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'facility',
                    title: 'SCHEDULE.LIST.COLUMNS.FACILITY'
                },
                 {
                    key: 'areaOfCare',
                    title: 'SCHEDULE.LIST.COLUMNS.AREA_OF_CARE'
                },
                {
                    key: 'date',
                    title: 'SCHEDULE.LIST.COLUMNS.DATE'
                },
                {
                    key: 'accountRep',
                    title: 'SCHEDULE.LIST.COLUMNS.ACCOUNT_REP'
                },
                {
                    key: 'notes',
                    title: 'SCHEDULE.LIST.COLUMNS.NOTES'
                },
                {
                    key: 'isDone',
                    title: 'SCHEDULE.LIST.COLUMNS.IS_DONE'
                }
            ],
            actions: {
                onDelete: (item) => this.deleteResource(item)
            }
        }));

        this.queryUtility.onResetFilter = ()=>{
            this.facilityStore.setValue(null);
            this.rangeQueryPickerStore.reset();
        }

        this.rangeQueryPickerStore = new DateRangeQueryPickerStore();

        this.facilityStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await facilityService.find({ searchQuery: term, rpp: 450, inActive: false, isOnHold:false });
                return response.data.item;
            }
        });
    } 
}

export default ScheduleViewStore;
